import { useFetchCallType } from '@rahtab/auth/lib/token-based-auth';
import { useEffect, useState } from 'react';
import { addLoads } from '../../rahtab-redux/slices/loadsSlice';
import { useAppDispatch, useSelector } from '../../rahtab-redux';
import { ServerFullInfo } from './useLoadsList';

export const useLoad = ({ assignFinalCode }: Args) => {
  const { loads } = useSelector((state) => state.loads);
  const dispatch = useAppDispatch();
  const finalCode = [assignFinalCode];
  const [refetch, { loading, data }] = useFetchCallType<ServerFullInfo[]>('GetInventoryAssignFinallInfo', {
    skip: !!loads[assignFinalCode],
    params: `AssignFinallCode=${JSON.stringify(finalCode)}`,
  });
  useEffect(() => {
    if (!loading && data) {
      dispatch(addLoads(data));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading, data]);

  return {
    refetch,
    loading: loading || !loads[assignFinalCode],
    called: !!loads[assignFinalCode],
    data: loads[assignFinalCode],
  };
};

interface Args {
  assignFinalCode: string;
}
